import React from 'react';
import styled from 'styled-components';
import {labels, setThousandSeparator, numberFormattedText, GetCardTypeForBody} from '../../../../../util/utils';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import NumberFormat from 'react-number-format';
import {useUserPreferences} from '../../../../../util/customHooks';

export function PrintViewNumericBody(props) {
	const {body} = props;
	const userPreferences = useUserPreferences();

	const formBodyBorder = GetCardTypeForBody(body);

	const getValue = (value) => {
		return numberFormattedText(userPreferences.numberFormat, value === null || value === undefined ? '' : value);
	};

	let priorYearValue;
	if (body.bodyRelatedObjects && body.bodyRelatedObjects.length > 0) {
		priorYearValue = body.bodyRelatedObjects[0]?.priorYearAmount;
	}

	let valFormatter = setThousandSeparator(userPreferences.numberFormat);

	const mainBodyKey = `form-body-${body.id}-numeric`;

	return (
		<StyledPrintViewNumericBody key={mainBodyKey} className={`StyledPrintViewNumericBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewNumericBodyData">
				<section key={`${mainBodyKey}-value`} className="numeric-body-value">
					<NumberFormat
						value={getValue(body.bodyFreeText)}
						isNumericString
						displayType="text"
						thousandSeparator={valFormatter.thousandSeparator}
						thousandsGroupStyle={valFormatter.thousandsGroupStyle}
						decimalSeparator={valFormatter.decimalSeparator}
					/>
				</section>
				{priorYearValue && (
					<section className="priorPeriodDetails">
						<span className="priorPeriodText">{labels.priorPeriodAmount}</span>
						<span className="priorPeriodValue">{getValue(priorYearValue)}</span>
					</section>
				)}
			</section>
		</StyledPrintViewNumericBody>
	);
}

const StyledPrintViewNumericBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.numeric-body-value {
		display: inline-block;
		padding: var(--px-1) var(--px-6);
		margin-top: var(--px-5);
		max-width: var(--px-200);
		min-width: var(--px-200);
		min-height: var(--px-25);
		border: var(--px-1) solid var(--neutrals-300) !important;
	}
	.priorPeriodDetails {
		display: inline-block;
		margin-left: var(--px-60);
		vertical-align: top;
		margin-top: var(--px-4);
		.priorPeriodText {
			font-size: var(--px-12);
			font-weight: 300;
			display: flex;
			color: var(--neutrals-700) !important;
			line-height: normal;
		}
		.priorPeriodValue {
			display: flex;
			font-size: var(--px-12);
			color: var(--neutrals-700) !important;
			line-height: normal;
		}
	}
`;

export default PrintViewNumericBody;
